import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { Reveal } from "./Reveal";
import { SUPPORTING } from "./assets";

const CHAPTERS = [
  {
    tag: "Chapter 01 \u00b7 The Declaration",
    text: "Saying it out loud is the first act. When you put your intention on the record, quitting quietly stops being an option.",
  },
  {
    tag: "Chapter 02 \u00b7 The Proof",
    text: "Intentions are cheap. Proof is not. A photo or a check-in turns a promise into a fact that can't be argued with.",
  },
  {
    tag: "Chapter 03 \u00b7 The Streak",
    text: "One kept promise is a moment. A hundred is an identity. The ledger remembers every single one \u2014 so you become someone who keeps their word.",
  },
];

export const Manifesto = () => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="manifesto" ref={ref} className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-36">
      <div className="grid grid-cols-1 gap-14 md:grid-cols-[1fr_1.2fr] md:gap-20">
        {/* Image column */}
        <Reveal className="relative">
          <div className="relative h-[420px] overflow-hidden border border-[#1F1F1F] md:h-full md:min-h-[560px]">
            <motion.img
              style={reduce ? {} : { y: imgY }}
              src={SUPPORTING.runner}
              alt="A runner at dawn — proof in motion"
              className="absolute inset-0 h-[130%] w-full object-cover opacity-90"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40" />
            <div className="absolute bottom-6 left-6 font-mono text-[11px] uppercase tracking-[0.2em] text-[#C9A94B]">
              [ The Manifesto ]
            </div>
          </div>
        </Reveal>

        {/* Text column */}
        <div>
          <Reveal>
            <h2 className="font-display text-5xl uppercase leading-[0.9] tracking-tight text-white md:text-7xl">
              Discipline is<br />just proof,<br />repeated.
            </h2>
          </Reveal>

          <div className="mt-12 border-t border-[#1F1F1F]">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.tag} delay={i * 0.08}>
                <div className="border-b border-[#1F1F1F] py-8">
                  <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#C9A94B]">
                    {c.tag}
                  </span>
                  <p className="mt-3 font-body text-xl leading-snug text-white md:text-2xl">
                    {c.text}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
